import React, { createContext, PropsWithChildren } from 'react';

export const PrivateRouteContext = createContext<{
    withReturnBack: boolean;
    isReturnBack: (value: boolean) => void;
}>({
    withReturnBack: true,
    isReturnBack: () => {},
});

export const PrivateRouteContextProvider: React.FC<PropsWithChildren> = ({ children }) => {
    const [state, setState] = React.useState<boolean>(true);

    const isReturnBack = (value: boolean) => {
        setState(value);
    };
    return (
        <PrivateRouteContext.Provider value={{ withReturnBack: state, isReturnBack }}>
            {children}
        </PrivateRouteContext.Provider>
    );
};
